import FieldDefs from './WordstatFieldDefs';
import {doLangFields} from '../../lib/ks-tools';

export default {
    template: `<div><slot v-bind="self" /></div>`,
    props: {
        projectId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            fields: doLangFields(this, "lang.wordstat.report.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'swsk',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            additionalActions: [],
            viewFullMode: false,
            options: [
                {label: this.$t('lang.wordstat.report.view_group_by_key'), value: false},
                {label: this.$t('lang.wordstat.report.view_full'), value: true},
            ],
        }
    },
    mounted() {
        this.viewFullMode = this.isFullMode;
    },
    computed: {
        getApiUrl() {
            return sprintf(
                '/wordstat/report?projectId=%d%s',
                this.projectId,
                (this.isFullMode ? '&full' : '')
            );
        },
        self() {
            return this;
        },
        isFullMode() {
            const params = new URLSearchParams(window.location.search);
            return params.has('full');
        },
        getHashes() {
            return window.location.hash;
        }
    },
    methods: {
        onChangeMode(event) {
            window.open(sprintf(
                '/wordstat-list/%d%s%s',
                this.projectId,
                event ? '?full' : '',
                this.getHashes
            ), '_self');
        },
    }
}
